import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { ContentComment } from '../db/ContentComment.js';

export const getCommentByReferenceAndContentID = registerQuery({
  type: () => ContentComment,
  operationName: 'getCommentByReferenceAndContentID',
  resolve: (referenceID: string, contentID: string) => {
    return async (gqlFields: BaseQLSelectionSet<ContentComment>) => {
      console.log('getCommentByReferenceAndContentID', { referenceID, contentID });
      const commentsCollection = await getCollection<ContentComment>(ContentComment._class);
      const comment = await commentsCollection.findOne<ContentComment>({ relatedEntityID: referenceID, contentID });
      return comment;
    };
  },
  params: [
    { name: 'referenceID', type: () => String },
    { name: 'contentID', type: () => String },
  ],
});
